import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import fuzzysort from 'fuzzysort';
import { isEmpty } from '@ember/utils';
import { next } from '@ember/runloop';

export default class extends Component {
  @service abilities;
  @service currentUser;
  @service fundGoalService;
  @service fundsService;
  @service powerMenu;
  @service router;
  @service settings;

  @tracked show = false;
  @tracked q = '';
  @tracked currentlySelectedIndex = 0;

  get filteredItems() {
    if (isEmpty(this.q)) {
      return this.powerMenu.currentOptions.map((x) => {
        return {
          obj: x,
          target: x.label,
          notFiltered: true,
        };
      });
    } else {
      return fuzzysort.go(this.q, this.powerMenu.currentOptions, {
        keys: ['searchByPrepared', 'labelPrepared'],
      });
    }
  }

  get currentOrganizationInfo() {
    return this.currentUser.isSiteAdmin
      ? `${this.currentUser.organizationDatabaseName} - ${this.currentUser.organizationId}`
      : undefined;
  }

  handleOptionChosen = async (option) => {
    if (option.fn) {
      await Promise.resolve(option.fn());
    } else if (option.models) {
      if (Array.isArray(option.models)) {
        this.router.transitionTo(option.route, ...option.models);
      } else {
        this.router.transitionTo(option.route, option.models);
      }
    } else {
      this.router.transitionTo(option.route);
    }
    this.show = false;
  };

  setCurrentlySelectedIndex = (index) => {
    this.currentlySelectedIndex = index;
  };

  handleSearchInput = (e) => {
    this.currentlySelectedIndex = 0;
    this.q = e.target.value;
  };

  handleSearchKeydown = (e) => {
    if (e.which === 38) {
      // up arrow
      if (this.currentlySelectedIndex > 0) {
        this.currentlySelectedIndex -= 1;
        this.confirmSelectedItemIsInViewPort();
      }
    } else if (e.which === 40) {
      // down arrow
      if (
        this.currentlySelectedIndex <
        this.powerMenu.currentOptions.length - 1
      ) {
        this.currentlySelectedIndex += 1;
        this.confirmSelectedItemIsInViewPort();
      }
    } else if (e.which === 13) {
      // enter
      this.handleOptionChosen(
        this.filteredItems[this.currentlySelectedIndex].obj,
      );
    }
  };

  confirmSelectedItemIsInViewPort() {
    next(() => {
      let selected = this.listGroupEl.querySelector('[aria-selected="true"]');
      let listGroupElScrollTop = this.listGroupEl.scrollTop;
      if (
        selected.offsetTop + 40 >
        listGroupElScrollTop + this.listGroupEl.clientHeight
      ) {
        this.listGroupEl.scrollTop = selected.offsetTop - 60;
      } else if (selected.offsetTop < listGroupElScrollTop) {
        this.listGroupEl.scrollTop = selected.offsetTop - 150;
      }
    });
  }

  handleListGroupInserted = (el) => {
    this.listGroupEl = el;
  };

  handleSearchInserted = (el) => {
    this.currentlySelectedIndex = 0;
    this.q = '';
    setTimeout(() => {
      el.focus();
    }, 50);
  };

  previousUrls = [null, null];
  handleRouteDidChange() {
    this.previousUrls = [this.previousUrls[1], this.router.currentURL];
  }

  templateDidInsert = () => {
    document.addEventListener('keydown', this.watchForHotKey);
    this.powerMenu.appendOptionsFn('go-back', this.powerMenuOptions);
    this.router.on('routeDidChange', this, this.handleRouteDidChange);
  };

  templateWillDestroy = () => {
    document.removeEventListener('keydown', this.watchForHotKey);
    this.powerMenu.removeOptions('go-back');
  };

  powerMenuOptions = () => {
    return [
      {
        label: 'Go Back',
        fn: () => {
          if (this.previousUrls[0]) {
            this.router.transitionTo(this.previousUrls[0]);
          }
        },
      },
    ];
  };

  hide = () => {
    this.show = false;
  };

  watchForHotKey = (e) => {
    // show modal when the "cmd/ctrl + k" combination is selected
    if (e.which === 75 && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.show = true;
    }
  };
}
